import type { Configuration } from "@azure/msal-browser";
import { LogLevel } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID as string,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID as string}`,
    redirectUri:
      (import.meta.env.VITE_REDIRECT_URI as string | undefined) ??
      window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // localStorage persists the MSAL account record across page refreshes so
    // users do not see the login screen after a reload. Access tokens are
    // short-lived (1 h) and refreshed silently; only the refresh token and
    // account metadata live in localStorage — both are scoped to this origin.
    // storeAuthStateInCookie preserves the nonce/state through the redirect cycle.
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (import.meta.env.DEV) {
          console.log(`[MSAL ${LogLevel[level]}]`, message);
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
    },
  },
};

// Scopes requested on login — must match the app registration in Entra ID
export const loginRequest = {
  scopes: [
    `api://${import.meta.env.VITE_AZURE_CLIENT_ID as string}/user_impersonation`,
  ],
};
